export default "__VITE_ASSET__CRb$kMmE__"